module.exports = __webpack_public_path__ + "2395bd55683f135fbf3ca77e726f276e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-4.png
// module id = 308
// module chunks = 1